// Bone information for humans, animals, birds, and amphibians
export const boneData = {
  human: {
    description: "Humans have 206 bones in adulthood, including the skull, spine, ribs, arms, and legs. The human skeleton is divided into the axial skeleton (skull, vertebral column, and rib cage) and the appendicular skeleton (limbs and girdles).",
    keyBones: [
      { name: "Skull", function: "Protects the brain and forms the structure of the face." },
      { name: "Spine (Vertebral Column)", function: "Supports the body and protects the spinal cord." },
      { name: "Ribs", function: "Protect the heart and lungs." },
      { name: "Femur", function: "Longest bone, supports the thigh." },
      { name: "Humerus", function: "Upper arm bone, supports arm movement." },
      { name: "Pelvis", function: "Supports the spinal column and protects abdominal organs." },
      { name: "Tibia", function: "Shin bone, supports lower leg." },
      { name: "Radius & Ulna", function: "Forearm bones, allow wrist rotation." },
      { name: "Clavicle (Collarbone)", function: "Connects arm to body, stabilizes shoulder." }
    ]
  },
  animal: {
    description: "Animals have diverse skeletal structures depending on their species. Most vertebrates have a backbone and similar bone types, but the number and shape of bones vary greatly.",
    examples: [
      { species: "Dog", bones: 319, note: "Dogs have more bones in their tails and paws." },
      { species: "Cat", bones: 230, note: "Cats have flexible spines and more vertebrae for agility." },
      { species: "Horse", bones: 205, note: "Horses have long limb bones for running." },
      { species: "Elephant", bones: 326, note: "Elephants have thick, strong bones to support their weight." }
    ],
    commonBones: [
      { name: "Skull", function: "Protects the brain." },
      { name: "Vertebrae", function: "Forms the backbone." },
      { name: "Ribs", function: "Protects internal organs." },
      { name: "Femur", function: "Supports hind limbs." }
    ]
  },
  bird: {
    description: "Birds have lightweight, hollow bones to aid in flight. Their skeletons are adapted for flying, with fused bones and a keeled sternum for muscle attachment.",
    keyBones: [
      { name: "Furcula (Wishbone)", function: "Strengthens the thoracic skeleton for flight." },
      { name: "Keel (Sternum)", function: "Attachment for powerful flight muscles." },
      { name: "Humerus", function: "Upper wing bone, supports flight." },
      { name: "Carpometacarpus", function: "Fused hand bones, supports wing feathers." },
      { name: "Pygostyle", function: "Supports tail feathers for steering." }
    ],
    note: "Birds typically have between 150-200 bones, depending on the species."
  },
  amphibian: {
    description: "Amphibians have bones adapted for both aquatic and terrestrial life. Their skeletons are generally less dense and more flexible than those of mammals or birds.",
    keyBones: [
      { name: "Skull", function: "Protects the brain." },
      { name: "Vertebrae", function: "Flexible spine for movement in water and on land." },
      { name: "Urostyle", function: "Fused tail vertebrae in frogs, aids in jumping." },
      { name: "Limb bones", function: "Support movement on land and swimming." }
    ],
    note: "The number of bones varies by species; frogs have fewer bones due to fusion for jumping."
  }
}; 